// Bloqueo de scroll de fondo compartido entre modales (trips list, ficha de viaje, etc.)
// Usa un contador: si dos modales están abiertos a la vez, el fondo no se desbloquea
// hasta que se cierran todos. Bloquea tanto <body> como .page-wrapper porque este tema
// hace scroll dentro de ese contenedor interno en escritorio, no en <body>.
window.ZDScrollLock = (function () {
  var count = 0;
  function targets() {
    var t = [document.body];
    var pageWrapper = document.querySelector('.page-wrapper');
    if (pageWrapper) t.push(pageWrapper);
    return t;
  }
  return {
    lock: function () {
      count++;
      targets().forEach(function (el) {
        el.style.overflow = 'hidden';
      });
    },
    unlock: function () {
      count = Math.max(0, count - 1);
      if (count === 0) {
        targets().forEach(function (el) {
          el.style.overflow = '';
        });
      }
    },
  };
})();

(function () {
  function initReveal() {
    var els = document.querySelectorAll('.zd-reveal:not([data-zd-bound])');
    if (!els.length) return;

    els.forEach(function (el) {
      el.setAttribute('data-zd-bound', '1');
      var delay = el.getAttribute('data-reveal-delay');
      if (delay) el.style.setProperty('--zd-reveal-delay', delay + 'ms');
    });

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  function initCountUp() {
    var els = document.querySelectorAll('.zd-count-up:not([data-zd-count-bound])');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.setAttribute('data-zd-count-bound', '1');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          el.setAttribute('data-zd-count-bound', '1');
          io.unobserve(el);

          var raw = (el.textContent || '').trim();
          var match = raw.match(/^(\D*)([\d.,]*\d)(\D*)$/);
          if (!match) return;

          var prefix = match[1];
          var suffix = match[3];
          var numStr = match[2];

          // Comma present: comma is the decimal separator, dots are thousands (1.234,5).
          // No comma but a single dot with 1-2 trailing digits: that dot is a decimal (5.0).
          // Otherwise dots are thousands separators (1.234).
          var decimals = 0;
          var normalized;
          if (numStr.indexOf(',') > -1) {
            var decPart = numStr.split(',').pop();
            decimals = decPart.length;
            normalized = numStr.replace(/\./g, '').replace(',', '.');
          } else if (/^\d{1,3}(\.\d{1,2})?$/.test(numStr) && numStr.indexOf('.') > -1) {
            decimals = numStr.split('.').pop().length;
            normalized = numStr;
          } else {
            normalized = numStr.replace(/\./g, '');
          }

          var target = parseFloat(normalized);
          if (isNaN(target)) return;

          var duration = 1200;
          var start = null;

          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var current = target * eased;
            var display = decimals
              ? current.toLocaleString('es-ES', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
              : Math.round(current).toLocaleString('es-ES');
            el.textContent = prefix + display + suffix;
            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              el.textContent = raw;
            }
          }

          requestAnimationFrame(step);
        });
      },
      { threshold: 0.4 }
    );

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  function init() {
    initReveal();
    initCountUp();
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
  document.addEventListener('shopify:section:load', init);
})();
